import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  activeStepServRec: 0,
  cartServRec: [],
  subtotalServRec: 0,
  totalServRec: 0,
  discountServRec: 0,
  //
  subtotalServ: 0,
  subtotalRec: 0,
  //
  billing: null,

  itemsSuccess: [],
  itemsError: [],

  listServicios: [],
  listRecargas: []
};

const slice = createSlice({
  name: 'dagpacketServRec',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setListaServicios: (state, action) => {
      const data = action.payload;

      state.listServicios = data;
    },

    setListaRecargas: (state, action) => {
      const data = action.payload;

      state.listRecargas = data;
    },

    // ======================================================

    addCart: (state, action) => {
      const product = action.payload;
      // const isEmptyCart = state.checkout.cart.length === 0;
      state.cartServRec = [...state.cartServRec, product];
      let sd = Number(state.subtotalServRec);
      state.subtotalServRec = state.cartServRec.map((c) => (sd += Number(c.shippingValue)));
      // slice.reducers.calcSubtotal();

      // ---local storage
      localStorage.setItem('cartServRec', JSON.stringify(state.cartServRec));
    },

    removeItem: (state, action) => {
      const id = action.payload;
      const newCart = state.cartServRec.filter((item) => item.object_id !== id);
      state.cartServRec = newCart;

      // ---local storage
      localStorage.setItem('cartServRec', JSON.stringify(state.cartServRec));
    },

    calcSubtotal: (state) => {
      let subTotal = 0;
      state.cartServRec.map((item) => (subTotal += parseFloat(item.enteredAmount)));
      state.subtotalServRec = subTotal;
      state.totalServRec = subTotal;

      let servicioAmount = 0;
      let recargaAmount = 0;

      const servFilter = state.cartServRec.filter((item) => item.type === 'servicio');
      servFilter.map((item) => {
        servicioAmount += parseFloat(item.enteredAmount);
        return false;
      });

      const recFilter = state.cartServRec.filter((item) => item.type === 'recarga');
      recFilter.map((item) => {
        recargaAmount += parseFloat(item.enteredAmount);
        return false;
      });

      state.subtotalServ = servicioAmount;
      state.subtotalRec = recargaAmount;
    },

    updateCartServRecItem: (state, action) => {
      const obj = action.payload;
      const id = obj.object_id;
      const newArr = state.cartServRec.filter((item) => item.object_id !== id);
      state.cartServRec = [...newArr, obj];

      // ---local storage
      localStorage.setItem('cartServRec', JSON.stringify(state.cartServRec));
    },

    resetCartServRec: (state) => {
      state.cartServRec = [];
      state.subtotalServRec = 0;
      state.totalServRec = 0;

      // ---local storage
      localStorage.setItem('cartServRec', JSON.stringify(state.cartServRec));
    },

    restartCartServRec: (state, action) => {
      const itemsList = action.payload ? action.payload : [];
      state.cartServRec = itemsList;
      state.subtotal = 0;
      state.total = 0;

      // // ---local storage
      // localStorage.setItem('cart', JSON.stringify(state.checkout.cart));
    },

    // steps

    resetActiveStepServRec(state) {
      state.activeStepServRec = 0;
    },
    onBackStepServRec(state) {
      state.activeStepServRec -= 1;
    },

    onNextStepServRec(state) {
      state.activeStepServRec += 1;
    },

    // items error - success

    setItemsSuccessServRec: (state, action) => {
      const id = action.payload;
      state.itemsSuccess = [...state.itemsSuccess, id];
    },
    setItemsErrorServRec: (state, action) => {
      const id = action.payload;
      state.itemsError = [...state.itemsError, id];
    },

    resetItemsSuccessServRec: (state) => {
      state.itemsSuccess = [];
    },
    resetItemsErrorServRec: (state) => {
      state.itemsError = [];
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  resetActiveStepServRec,
  onBackStepServRec,
  onNextStepServRec,
  resetCartServRec,
  setItemsSuccessServRec,
  setItemsErrorServRec,
  resetItemsSuccessServRec,
  resetItemsErrorServRec,
  updateCartServRecItem,

  setListaServicios,
  setListaRecargas
} = slice.actions;

// ----------------------------------------------------------------------

export const addCartServRecAction = (item) => (dispatch) => {
  dispatch(slice.actions.addCart(item));
  dispatch(slice.actions.calcSubtotal());
};

export const removeItemServRecAction = (id) => (dispatch) => {
  dispatch(slice.actions.removeItem(id));
  dispatch(slice.actions.calcSubtotal());
};

export const restartCartServRecAction = (item) => (dispatch) => {
  dispatch(slice.actions.restartCartServRec(item));
  dispatch(slice.actions.calcSubtotal());
};
